import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';

import { EmployeeService } from '../../services/employee.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { JobService } from '../../services/job.service';
import { RoleService } from '../../services/role.service';
import { CheckClockService } from '../../services/check-clock.service';
import { DepartmentService } from '../../services/department.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';

function notRequiredEmailValidator(control: FormControl) {
    if (!control.value) {
        return null;
    }

    return Validators.email(control);
}

@Component({
    selector: 'app-create-unregistered-employee',
    templateUrl: './create-unregistered-employee.component.html',
    styleUrls: ['./create-unregistered-employee.component.css', '../../app.component.css']
})

export class CreateUnregisteredEmployeeComponent implements OnInit, OnDestroy {

    unregisteredEmployeeForm: FormGroup;
    employee: any;

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    roles = {};
    roleInit: any;
    roleText = '';

    jobs = {};
    jobInit: any;
    jobText = '';

    departments = {};
    departmentInit: any;
    departmentText = '';

    pickadateParams = Utils.pickadateParams();

    modalActions = new EventEmitter<string|MaterializeAction>();
    modalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    jobForm: FormGroup;
    job: any;

    transportArriveVal: number;
    carriers = {};
    carrierInit: any;
    carrierText = '';

    checkClockLoad: string;
    folio: number;

    gsSubs: Subscription;
    grSubs: Subscription;
    geSubs: Subscription;
    gjSubs: Subscription;
    gccbfSubs: Subscription;
    gdSubs: Subscription;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private employeeService: EmployeeService,
                private subsidiaryService: SubsidiaryService,
                private jobService: JobService,
                private roleService: RoleService,
                private checkClockService: CheckClockService,
                private departmentService: DepartmentService) {
        this.activatedRoute.parent.params.subscribe(parentParameters => {
            this.checkClockLoad = parentParameters['id'];

            this.activatedRoute.params.subscribe(parameters => {
                this.folio = parseInt(parameters['folio']);

                this.transportArriveVal = 0;

                this.loadSubsidiariesAndRolesAndCarriersAndDepartments();
                this.loadJobs();
            });
        });
    }

    ngOnInit() {
        this.unregisteredEmployeeForm = this.formBuilder.group({
            name: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', notRequiredEmailValidator],
            admissionDate: '',
            internalKey: '',
            subsidiary: ['', Validators.required],
            role: '',
            job: ['', Validators.required],
            department: '',
            transportArrive: ['', Validators.required],
            carrier: ''
        });

        this.jobForm = this.formBuilder.group({
            nameJob: ['', Validators.required],
            descriptionJob: ['', Validators.required],
            internalNumberJob: ['', Validators.required],
            baseSalaryJob: ['', [Validators.required, Validators.pattern('[0-9]+(\.[0-9][0-9]?)?')]]
        });
    }

    onSubmitUnregisteredEmployee() {
        this.employee = this.saveUnregisteredEmployee();
        const self = this;

        this.employeeService.postEmployee(this.employee).then(res => {
            this.gccbfSubs = this.checkClockService.getCheckClocksByFolio(this.folio).subscribe(tempCheckClocks => {
                this.gccbfSubs.unsubscribe();

                const recordsToBatch = [];
                const currentDate = new Date();

                for (let idx in tempCheckClocks) {
                    const checkClockJson = {
                        id: tempCheckClocks[idx].id$,
                        employeeId: res,
                        updatedAt: currentDate
                    };

                    recordsToBatch.push(checkClockJson);
                }

                this.checkClockService.putCheckClockAtomic(recordsToBatch).then(function() {
                    self.unregisteredEmployeeForm.reset();

                    self.router.navigate(['/vw_check_clock/' + self.checkClockLoad, { outlets: {
                        'tab_registered_employees': ['registered_employees'],
                        'tab_unregistered_employees': ['unregistered_employees']
                    }}]);
                });
            });
        });
    }

    saveUnregisteredEmployee() {
        let admissionDate: any;
        if (this.unregisteredEmployeeForm.get('admissionDate').value) {
            admissionDate = Utils.convertDatefromISOStringtoObject(this.unregisteredEmployeeForm.get('admissionDate').value);
        } else {
            admissionDate = '';
        }

        const transportArrive = parseInt(this.unregisteredEmployeeForm.get('transportArrive').value);
        let carrierId: string;
        if (Math.floor(transportArrive) === 3) {
            carrierId = this.carriers[this.unregisteredEmployeeForm.get('carrier').value];
        } else {
            carrierId = '';
        }

        const currentDate = new Date();

        let roleId = '';
        if (this.unregisteredEmployeeForm.get('role').value) {
            roleId = this.roles[this.unregisteredEmployeeForm.get('role').value];
        }

        let departmentId = '';
        if (this.unregisteredEmployeeForm.get('department').value) {
            departmentId = this.departments[this.unregisteredEmployeeForm.get('department').value];
        }

        const employeeJson = {
            active: 1,
            activityId: this.jobs[this.unregisteredEmployeeForm.get('job').value],
            admissionDate: admissionDate,
            carrierId: carrierId,
            createdAt: currentDate,
            email: this.unregisteredEmployeeForm.get('email').value,
            imageUrl: '',
            internalKey: this.unregisteredEmployeeForm.get('internalKey').value,
            lastName: this.unregisteredEmployeeForm.get('lastName').value,
            name: this.unregisteredEmployeeForm.get('name').value,
            password: '',
            roleId: roleId,
            salt: '',
            subsidiaryId: this.subsidiaries[this.unregisteredEmployeeForm.get('subsidiary').value],
            token: '',
            transportArrive: transportArrive,
            updatedAt: currentDate,
            departmentId: departmentId
        };

        return employeeJson;
    }

    loadSubsidiariesAndRolesAndCarriersAndDepartments() {
        this.gsSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const dataSubsidiary = {};

            for (const idx in tempSubsidiaries) {
                dataSubsidiary[tempSubsidiaries[idx].name] = null;
                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': dataSubsidiary,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.subsidiaries[val]);
                }
            };
        });

        this.grSubs = this.roleService.getRoles().subscribe(tempRoles => {
            const dataRole = {};

            for (const idx in tempRoles) {
                dataRole[tempRoles[idx].name] = null;
                this.roles[tempRoles[idx].name] = tempRoles[idx].id$;
            }

            this.roleInit = {
                'data': dataRole,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.roles[val]);
                }
            };
        });

        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const dataEmployee = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.carriers[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.carrierInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.carriers[val]);
                }
            };

            this.carrierText = tempEmployees[0].name + ' ' + tempEmployees[0].lastName;
        });

        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDepartments => {
            const dataDepartment = {};

            for (const idx in tempDepartments) {
                dataDepartment[tempDepartments[idx].name] = null;
                this.departments[tempDepartments[idx].name] = tempDepartments[idx].id$;
            }

            this.departmentInit = {
                'data': dataDepartment,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.departments[val]);
                }
            };
        });
    }

    loadJobs() {
        this.gjSubs = this.jobService.getJobs().subscribe(tempJobs => {
            const dataJob = {};

            for (const idx in tempJobs) {
                dataJob[tempJobs[idx].name + ' - ' + tempJobs[idx].baseSalary] = null;
                this.jobs[tempJobs[idx].name + ' - ' + tempJobs[idx].baseSalary] = tempJobs[idx].id$;
            }

            this.jobInit = {
                'data': dataJob,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.jobs[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    onBlurRole() {
        if (this.roles[this.roleText] === undefined) {
            this.roleText = '';
        }
    }

    onBlurJob() {
        if (this.jobs[this.jobText] === undefined) {
            this.jobText = '';
        }
    }

    onBlurDepartment() {
        if (this.departments[this.departmentText] === undefined) {
            this.departmentText = '';
        }
    }

    onBlurCarrier() {
        if (this.carriers[this.carrierText] === undefined) {
            this.carrierText = '';
        }
    }

    openModal() {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeModal() {
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    }

    onSubmitJob() {
        this.job = this.saveJob();

        this.jobService.postJob(this.job).then(res => {
            this.jobForm.reset();

            this.loadJobs();

            this.closeModal();

            this.jobText = this.job.name + ' - ' + this.job.baseSalary;
        });
    }

    saveJob() {
        const currentDate = new Date();

        const jobJson = {
            active: true,
            baseSalary: this.jobForm.get('baseSalaryJob').value,
            createdAt: currentDate,
            description: this.jobForm.get('descriptionJob').value,
            internalNumber: this.jobForm.get('internalNumberJob').value,
            name: this.jobForm.get('nameJob').value,
            subsidiaryId: this.subsidiaries[this.unregisteredEmployeeForm.get('subsidiary').value],
            updatedAt: currentDate
        };

        return jobJson;
    }

    ngOnDestroy() {
        this.gsSubs.unsubscribe();
        this.grSubs.unsubscribe();
        this.geSubs.unsubscribe();
        this.gjSubs.unsubscribe();
        this.gdSubs.unsubscribe();
    }

}
